export default __webpack_public_path__ + "static/weather--wind-6ccd2d64f403e13d50737f762b9917e7.png";